"use strict";
exports.__esModule = true;
var _utils = require("../utils");
exports["default"] = function(instance) {
  instance.registerDecorator("inline", function(fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function(context, options2) {
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret2 = fn(context, options2);
        container.partials = original;
        return ret2;
      };
    }
    props.partials[options.args[0]] = options.fn;
    return ret;
  });
};
module.exports = exports["default"];
